import Vue from 'vue';
import axios from 'axios';
import '../../filters';
import moment from 'moment';
import DxDateBox from 'devextreme-vue/date-box';
import { DxTextBox, DxCheckBox, DxNumberBox } from 'devextreme-vue';
import DxRadioGroup from 'devextreme-vue/radio-group';

const uiDateFormat = 'DD/MM/YYYY';

export default {
  name: 'receipting',
  components: {
    DxRadioGroup,
    DxTextBox,
    DxCheckBox,
    DxNumberBox,
    DxDateBox,
    InstallmentComp: require('./installment.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      newAgreement: {
        account: '',
        agreementAmount: 0,
        balance: 0,
        billingGroup: '',
        effectiveDate: new Date(),
        guarantorAddress: '',
        guarantorEmail: '',
        guarantorId: '',
        guarantorName: '',
        guarantorTel: '',
        immediatePayment: 0,
        installmentAmount: 0,
        installmentCount: 0,
        installmentType: 0,
        installments: [],
        name: '',
        oldKey: null,
        penaltyType: 0,
        penaltyValue: 0,
        reference: '',
        remarks: null,
        status: '',
        vatAmount: 0,
        vatType: '',
      },
      installmentMethod: '',
      penaltyMethod: '',
      readOnly: true,
      totalAmount: 0,
      editingInstallment: { },
      bShowInstallment: false,
      methods: [this.$t('customerAgreements.noOfinstallments'), this.$t('customerAgreements.installmentAmount')],
      penalties: [this.$t('customerAgreements.None'), this.$t('customerAgreements.Percentage'), this.$t('customerAgreements.Fixed')],
    }
  },
  computed: {
    languageLocale: function () {
      return this.$i18n.locale;
    },
  },
  watch: {
    languageLocale: function (value) {

    },
  },
  created() {
    this.newAgreement = this.dataObj;
    this.$root.$on('agreement_data_updated', this.init);
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.newAgreement = this.dataObj;
        this.readOnly = this.newAgreement.status !== 'Pending';
        this.installmentMethod = this.methods[this.newAgreement.installmentType];
        this.penaltyMethod = this.penalties[this.newAgreement.penaltyType];
        this.totalAmount = 0;
        this.newAgreement.installments.forEach(item => this.totalAmount += item.amount);
      });
    },
    addInstallment() {
      this.editingInstallment = {
        instNo: this.newAgreement.installments.length + 1,
        chargeDate: new Date(),
        amount: 0,
        mode: 'Add'
      };
      this.bShowInstallment = true;
    },
    editInstallment(installment) {
      this.editingInstallment = installment;
      this.editingInstallment.mode = 'Edit';
      this.bShowInstallment = true;
    },
    deleteInstallment(instId) {
      this.newAgreement.installments = this.newAgreement.installments.filter(item => item.instNo !== instId);
      var index = 1;
      this.newAgreement.installments.forEach(item => item.instNo = index++);
      this.totalAmount = 0;
      this.newAgreement.installments.forEach(item => this.totalAmount += item.amount);
      this.editingApplicant = null;
    },
    saveInstallment() {
      if (this.editingInstallment.amount === 0) {
        this.$alertMsg(this.$t('messages.amountCannotBeZero'));
        return;
      }
      if (this.editingInstallment.mode === 'Add')
        this.newAgreement.installments.push(this.editingInstallment);
      this.totalAmount = 0;
      this.newAgreement.installments.forEach(item => this.totalAmount += item.amount);
      this.bShowInstallment = false;
    },
    closeInstallment() {
      this.editingInstallment = null;
      this.bShowInstallment = false;
    },
    changeSelectionMethod(e) {
      this.newAgreement.installmentType = this.methods.indexOf(e.value);
    },
    changeSelectionPenalty(e) {
      this.newAgreement.penaltyType = this.penalties.indexOf(e.value);
      this.newAgreement.penaltyValue = 0;
    },
    formatMoney(number, decPlaces, decSep, thouSep) {
      decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
        decSep = typeof decSep === "undefined" ? "." : decSep;
      thouSep = typeof thouSep === "undefined" ? "," : thouSep;
      var sign = number < 0 ? "-" : "";
      var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
      var j = (j = i.length) > 3 ? j % 3 : 0;

      return sign +
        (j ? i.substr(0, j) + thouSep : "") +
        i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
        (decPlaces ? decSep + Math.abs(number - parseInt(i)).toFixed(decPlaces).slice(2) : "");
    },
    recalculate() {
      if (this.newAgreement.installmentType === 1)
        if (this.newAgreement.installmentAmount <= 0)
          this.$alertMsg(this.$t('messages.amountCannotBeZero'));
        else
          this.createInstallmentsByAmount(this.newAgreement.agreementAmount - this.newAgreement.immediatePayment, this.newAgreement.installmentAmount)

      if (this.newAgreement.installmentType === 0)
        if (this.newAgreement.installmentCount <= 0)
          this.$alertMsg(this.$t('messages.countCannotBeZero'));
        else
          this.createInstallmentsByCount(this.newAgreement.agreementAmount - this.newAgreement.immediatePayment, this.newAgreement.installmentCount)
        
    },
    createInstallmentsByCount(total, count) {
      var parameter = {
        totalAmount: total,
        installmentCount: count,
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/CustomerAgreement/CreateInstallmentsByCount?' + 'totalAmount=' + parameter.totalAmount + '&installmentCount=' + parameter.installmentCount)
        .then(response => {
          if (response.status == 200) {
            this.newAgreement.installments = response.data;
            this.totalAmount = 0;
            this.newAgreement.installments.forEach(item => this.totalAmount += item.amount);
          }
          loader.hide();
        })
        .catch(error => {
          loader.hide();
          this.$alertMsg(error.response.data);
        })
    },
    createInstallmentsByAmount(total, installment) {
      var parameter = {
        totalAmount: total,
        installmentAmount: installment,
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/CustomerAgreement/CreateInstallmentsByAmount?' + 'totalAmount=' + parameter.totalAmount + '&installmentAmount=' + parameter.installmentAmount)
        .then(response => {
          if (response.status == 200) {
            this.newAgreement.installments = response.data;
            this.totalAmount = 0;
            this.newAgreement.installments.forEach(item => this.totalAmount += item.amount);
          }
          loader.hide();
        })
        .catch(error => {
          loader.hide();
          this.$alertMsg(error.response.data);
        })
    },
    addDays(date, days) {
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + days);
    },
    addMonthsUTC(date, count) {
      if (date && count) {
        var m, d = (date = new Date(+date)).getUTCDate()

        date.setUTCMonth(date.getUTCMonth() + count, 1)
        m = date.getUTCMonth()
        date.setUTCDate(d)
        if (date.getUTCMonth() !== m) date.setUTCDate(0)
      }
      return date
    },
    addMonths(date, count) {
      if (date && count) {
        var m, d = (date = new Date(+date)).getDate()

        date.setMonth(date.getMonth() + count, 1)
        m = date.getMonth()
        date.setDate(d)
        if (date.getMonth() !== m) date.setDate(0)
      }
      return date
    },
    formatDateUI(date) {
      return moment(date).add(1, 'days').format(uiDateFormat);
    },
    roundNumberV2(value, decimals) {
      return Number(Math.round(Number(value + 'e' + decimals)) + 'e-' + decimals);
    },
    roundNumberV1(num, scale) {
      var arr = ('' + num).split('e');
      var sig = ''
      if (+arr[1] + scale > 0) {
        sig = '+';
      }
      var i = +arr[0] + 'e' + sig + (+arr[1] + scale);
      var j = Math.round(Number(i));
      var k = +(j + 'e-' + scale);
      return k;
    },
  },
}
